(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('object-test-result', {
                parent: 'testing',
                url: '/object-test-result/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.objectTestResult.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/object-test-result/object-test-result.html',
                        controller: 'ObjectTestResultController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: {
                        value: null,
                        squash: true
                    },
                    scheduleId: {value: null},
                    fromManualTests: {value: false}
                },
                resolve: {
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    scheduleId: ['$stateParams', function ($stateParams) {
                        return $stateParams.scheduleId;
                    }],
                    fromManualTests: ['$stateParams', function ($stateParams) {
                        return $stateParams.fromManualTests;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('objectTestResult');
                        $translatePartialLoader.addPart('objectTestSetting');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).state('object-test-result.history', {
                parent: 'testing',
                url: '/object-test-result-history?object&id',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.objectTestResult.history.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/object-test-result/object-test-result-history.html',
                        controller: 'ObjectTestResultHistoryController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    object: {
                        value: null,
                        squash: true
                    },
                    id: {
                        value: null
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            object: $stateParams.object,
                            id: $stateParams.id
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('objectTestResult');
                        $translatePartialLoader.addPart('objectTestSetting');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).state('object-test-result.history-delete', {
            parent: 'object-test-result.history',
                url: '/delete/{name}/{type}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/object-test-result/object-test-result-history-delete-dialog.html',
                        controller: 'ObjectTestResultDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            name: [function () {
                                return $stateParams.name;
                            }],
                            type: [function () {
                                return $stateParams.type;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('object-test-result.history', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
